import React from "react";

const RecommendationSystems = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">Recommendation Systems</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Provide personalized content and recommendations based on user behavior and preferences.
      </p>
      <textarea
        className="mt-4 w-full max-w-2xl bg-gray-800 text-white p-4 rounded-lg"
        rows={6}
        placeholder="Enter sample user preferences or past interactions..."
      ></textarea>
      <button className="mt-4 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold rounded-lg shadow-lg">
        Generate Recommendations
      </button>
    </div>
  );
};

export default RecommendationSystems;